var RequestStatus = {
  NEW: 0,
  PENDING: 1,
  DONE: 2,
  CANCEL: 3,
};

module.exports = RequestStatus;
